import React from 'react';
import { Cell } from 'react-table';
import counterpartyImage from '../../../assets/images/blockchains/counterparty.png';
import klaytnImage from '../../../assets/images/blockchains/klaytn.png';
import ethereumImg from '../../../assets/images/blockchains/ethereum.png';
import noImageFound from '../../../assets/images/no-image-found.jpg';
import Blockchain from '../../../enums/blockchain-enum';

const blockchainFormatter = (cell: Cell): JSX.Element => {
  let blockchainImage = noImageFound;
  if (cell.value === Blockchain.Counterparty) {
    blockchainImage = counterpartyImage;
  } else if (cell.value === Blockchain.Klaytn) {
    blockchainImage = klaytnImage;
  } else if (cell.value === Blockchain.Ethereum) {
    blockchainImage = ethereumImg;
  }
  return (
    <div className="cell-blockchain">
      <img src={blockchainImage} alt="blockchain" />
      <div>{cell.value}</div>
    </div>
  );
};

export default blockchainFormatter;
